import { ROUTES } from 'router/routes';
import { SUPPORT_EMAIL, SUPPORT_TEL_HREF } from 'utils/constants';

export type FooterLink = {
  labelId: string;
  defaultLabel: string;
} & ({ to: string; href?: never } | { href: string; to?: never });

export type FooterLinkGroup = {
  titleId: string;
  defaultTitle: string;
  links: FooterLink[];
};

/** Normalise a ROUTES value (some carry a leading slash, some don't) into a router path. */
const toPath = (route: string) => (route.startsWith('/') ? route : `/${route}`);

export const LINK_GROUPS: FooterLinkGroup[] = [
  {
    titleId: 'footer.events',
    defaultTitle: 'Events',
    links: [
      { to: toPath(ROUTES.concerts), labelId: 'navbar.concert', defaultLabel: 'Concerts' },
      { to: toPath(ROUTES.matches), labelId: 'navbar.matches', defaultLabel: 'Matches' },
      { to: toPath(ROUTES.workshops), labelId: 'navbar.workshops', defaultLabel: 'Workshops' },
    ],
  },
  {
    titleId: 'footer.platform',
    defaultTitle: 'Platform',
    links: [
      { to: toPath(ROUTES.aboutUs), labelId: 'footer.about', defaultLabel: 'About Ticket Zone' },
      {
        to: toPath(ROUTES.b2bLanding),
        labelId: 'navbar.forOrganizers',
        defaultLabel: 'For Organizers',
      },
      { to: toPath(ROUTES.history), labelId: 'navbar.myTickets', defaultLabel: 'My Tickets' },
    ],
  },
  {
    titleId: 'footer.support',
    defaultTitle: 'Support',
    links: [
      { href: SUPPORT_TEL_HREF, labelId: 'footer.supportCenter', defaultLabel: 'Help Center' },
      {
        to: toPath(ROUTES.termsOfUse),
        labelId: 'footer.terms',
        defaultLabel: 'Terms & Conditions',
      },
      { href: `mailto:${SUPPORT_EMAIL}`, labelId: 'footer.contactUs', defaultLabel: 'Contact Us' },
    ],
  },
];
